import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import itemLogo from "../../../assets/img/items/item_1.png";
import { Badge } from "react-bootstrap";
import { useSelector } from "react-redux";
import { FaRegCirclePlay } from "react-icons/fa6";
import { avatar, DefaultProfile } from "../../../assets/img";
import { likeNFT } from "../../../hooks/NFTHook";

const userId = localStorage.getItem("userId");

const AuctionDynamicNFTCard = ({
    NFTLink,
    currentOwnerPic,
    currentOwnerName,
    currentOwnerLink,
    mediaUrl,
    assetType,
    title,
    likes,
    isLiked,
    isListed,
    isProfile,
    currentActive,
    endTime,
    nftId
}) => {
    const [hover, setHover] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const location = useLocation();
    const [fav, setFav] = useState(isLiked);
    const [likeCount, setLikeCount] = useState(likes);
    const route = useNavigate();
    const handleLike = (e) => {
        console.log("handleLike triggered"); // Debug log
        e.stopPropagation();

        if (!userId) {
            toast.dismiss();
            toast.error("Please login first!");
            return;
        }

        const body = { userId: userId };

        if (!fav) {
            console.log("Liking NFT"); // Debug log
            toast.dismiss();
            likeNFT(nftId, body)
                .then((data) => {
                    if (data.success) {
                        console.log("Like Data", data);
                        setLikeCount(Number(likeCount) + 1)
                        setFav(true);
                        toast.success("Liked Successfully!");
                    }
                })
                .catch((error) => {
                    console.error("Error liking NFT:", error);
                    toast.error("Failed to like. Please try again.");
                });
        } else {
            console.log("Disliking NFT"); // Debug log
            toast.dismiss();
            likeNFT(nftId, body)
                .then((data) => {
                    if (data.success) {
                        setLikeCount(Number(likeCount) - 1)

                        setFav(false);
                        toast.success("Disliked Successfully!");
                    }
                })
                .catch((error) => {
                    console.error("Error unliking NFT:", error);
                    toast.error("Failed to dislike. Please try again.");
                });
        }
    };

    const redirect = () => {
        if (location.pathname.split('/')[1] === "nftdetails") {
            localStorage.setItem('stateManage', true)
            route(NFTLink)
        }
        else {
            route(NFTLink)
        }
    }

    return (
        <>
            <div
                className={` ${hover ? "hovered" : ""}`}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >
                <div onClick={() => redirect()}>
                    <div className="card__item four">
                        <div className="card_body space-y-10">
                            {/* Creator Section */}
                            <div className="creators space-x-10">
                                {isProfile &&
                                    <div className="avatars space-x-3">
                                        <Link to={currentOwnerLink}>
                                            <img
                                                src={currentOwnerPic !== null ? currentOwnerPic : DefaultProfile}
                                                // alt="Creator"
                                                className="avatar avatar-sm"
                                            />
                                        </Link>
                                        <Link to={currentOwnerLink}>
                                            <p className="avatars_name txt_xs">{currentOwnerName || "Unknown"}</p>
                                        </Link>
                                    </div>
                                }
                                <div>
                                    {currentActive === true &&
                                        <Badge pill bg="success">Active</Badge>
                                    }
                                    {isListed === false &&
                                        <Badge pill bg="danger" className="ml-2">Not Listed</Badge>
                                    }
                                </div>
                            </div>
                            <div className="card_head">
                                {assetType?.split("/")[0] !== "image" ? (
                                    <div
                                        className="video-wrapper"
                                        onMouseEnter={() => setIsHovered(true)}
                                        onMouseLeave={() => setIsHovered(false)}
                                    >
                                        <video
                                            style={{ borderRadius: "18px" }}
                                            muted
                                            loop
                                            playsInline
                                            className={`video ${isHovered ? "playing" : ""}`}
                                            onMouseEnter={(e) => e.target.play()}
                                            onMouseLeave={(e) => e.target.pause()}
                                        >
                                            <source src={mediaUrl} type={assetType} />
                                            Your browser does not support the video tag.
                                        </video>
                                        {!isHovered && <div className="pause-overlay"><FaRegCirclePlay /></div>}
                                    </div>
                                ) : (
                                    <img
                                        src={mediaUrl}
                                        alt={`Preview ${assetType}`}
                                        style={{ borderRadius: "18px" }}
                                    />
                                )}

                                <div className="likes space-x-3">
                                    <div
                                        className={`like-icon ${fav ? "liked" : ""}`}

                                        style={{ cursor: "pointer" }}
                                    >
                                        {fav ? (
                                            <span style={{ color: "red" }} onClick={handleLike}>{likeCount} ❤️</span>
                                        ) : (
                                            <span style={{ color: "red" }} onClick={handleLike}> <span> {Number(likeCount) !== 0 && likeCount} </span>♡</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <h6 className="card_title">
                                <Link className="color_black" to="item-details">
                                    {title}
                                </Link>
                            </h6>
                            {/* Footer Section */}
                            <div className="card_footer d-block space-y-10">
                                <div className="d-flex align-items-center space-x-5">
                                    <div className="card_footer d-block space-y-10">
                                        <div className="card_footer justify-content-between">
                                            <div className="txt_sm">
                                                Auction End: {" "}
                                                <span className="color_green txt_sm">
                                                    {endTime}

                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </>
    );
};

// Prop Validation
AuctionDynamicNFTCard.propTypes = {
    NFTLink: PropTypes.string,
    contractAddress: PropTypes.string,
    currentOwnerPic: PropTypes.string,
    currentOwnerName: PropTypes.string,
    currentOwnerLink: PropTypes.string,
    mediaUrl: PropTypes.string,
    assetType: PropTypes.string,
    isVideo: PropTypes.bool,
    title: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    likes: PropTypes.number,
    isLiked: PropTypes.bool,
    isListed: PropTypes.bool,
    button: PropTypes.bool,
    buttonMessage: PropTypes.string,
    isProfile: PropTypes.bool,
    endTime: PropTypes.string,
    nftId: PropTypes.string

};

AuctionDynamicNFTCard.defaultProps = {
    NFTLink: "nftType/contactAddress/tokenId(_id)",
    contractAddress: "contractAddress",
    currentOwnerPic: avatar,
    currentOwnerName: "Unknown",
    currentOwnerLink: `${`/otherProfile/creatorAddress`}`,
    mediaUrl: itemLogo,
    assetType: "image",
    isVideo: false,
    title: "title",
    price: null,
    likes: 0,
    isLiked: false,
    isListed: true,
    button: false,
    buttonMessage: "Button",
    isProfile: true,
    endTime: 0,
    nftId: ""
};

export default AuctionDynamicNFTCard;
